// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"576071d54ddaded09eaa","258":"3b6966f81eeb0a3662ee"}[chunkId] + ".js");